import RuneQuestionIcon from 'images/coin-pages/questions/rune.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const runePage: ICoinPageData = {
  title: 'coin_835',
  description: 'coin_836',
  // description: 'coin_837',
  h1: (t: (key: unknown) => any) => (<>
    {t('borrow_against_bone')} <span style={{ color: '#f90' }}>THORChain</span>
  </> 
  ),
  questionsBlock: {
    image: RuneQuestionIcon,
    questions: [
      {
        title: 'coin_838',
        answer: 'coin_839',
      },
      {
        title: 'coin_840',
        answer: 'coin_841',
      },
      {
        title: 'coin_842',
        answer: 'coin_843',
      },
      {
        title: 'coin_844',
        answer: 'coin_845',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('THORChain (RUNE)'),
    text: [],
    paragraphs: [
      {
        title: 'coin_846',
        text: ['coin_848', 'coin_849', 'coin_850', 'coin_851'],
      },
      {
        title: 'coin_847',
        text: ['coin_852', 'coin_853', 'coin_854', 'coin_855'],
      },
    ],
    blogCards: [
      blogCards.borrowLikePro,
      blogCards.howCryptoAssetsSecured,
      blogCards.whatTypesOfCryptoLoansAreThereAndHowCanIProfitFromIt,
    ],
  },
}
